import { render } from "./MyDetails.vue?vue&type=template&id=576f72f6&scoped=true"
import script from "./MyDetails.vue?vue&type=script&lang=js"
export * from "./MyDetails.vue?vue&type=script&lang=js"

import "./MyDetails.vue?vue&type=style&index=0&id=576f72f6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576f72f6"]])

export default __exports__